import React from "react";
import { useSearchParams } from "react-router-dom";
import Integration from "@/model/interface/Integration";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PodioSetup from "./PodioSetup";
import PodioSettings from "./PodioSettings";
import PodioFieldMapping from "./PodioFieldMapping";
import PodioUserMapping from "./PodioUserMapping";
import PodioWebhook from "./PodioWebhook";
import IntegrationSyncLog from "../IntegrationSyncLog";
import IntegrationPushQueue from "../IntegrationPushQueue";

const TABS = ["setup", "settings", "field-mapping", "user-mapping", "webhook", "push-queue", "sync-log"] as const;
type Tab = (typeof TABS)[number];

interface Props {
  integration: Integration;
}

export default function PodioDetail({ integration }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: Tab = TABS.includes(tabParam as Tab) ? (tabParam as Tab) : "setup";

  const setTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <Tabs value={activeTab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="setup">Setup</TabsTrigger>
        <TabsTrigger value="settings">Settings</TabsTrigger>
        <TabsTrigger value="field-mapping">Field Mapping</TabsTrigger>
        <TabsTrigger value="user-mapping">User Mapping</TabsTrigger>
        <TabsTrigger value="webhook">Webhook</TabsTrigger>
        <TabsTrigger value="push-queue">Push Queue</TabsTrigger>
        <TabsTrigger value="sync-log">Sync Log</TabsTrigger>
      </TabsList>

      <TabsContent value="setup" className="mt-6">
        <PodioSetup integration={integration} />
      </TabsContent>

      <TabsContent value="settings" className="mt-6">
        <PodioSettings integration={integration} />
      </TabsContent>

      <TabsContent value="field-mapping" className="mt-6">
        <PodioFieldMapping integration={integration} />
      </TabsContent>

      <TabsContent value="user-mapping" className="mt-6">
        <PodioUserMapping integration={integration} />
      </TabsContent>

      <TabsContent value="webhook" className="mt-6">
        <PodioWebhook />
      </TabsContent>

      <TabsContent value="push-queue" className="mt-6">
        <IntegrationPushQueue service={integration.service} />
      </TabsContent>

      <TabsContent value="sync-log" className="mt-6">
        <IntegrationSyncLog integrationId={integration.id} />
      </TabsContent>
    </Tabs>
  );
}
